import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import { AddressAddition } from 'src/app/models/address';
import { AddressSuccess } from '../../models/address';
import { APIConstants } from 'src/app/app.constants';
@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private httpClient: HttpClient) { }
  readonly url = APIConstants.BASE_URL;

  getAddress(userId: string, authorization: string): Observable<any> {
    const params1 = new HttpParams().set('userId', userId);
    const headers = new HttpHeaders({
      Authorization: authorization
    });
    const options = {headers, params: params1};
    return this.httpClient.get<any>(this.url + '/address', options);
  }

  addAddress(addressInfo: AddressAddition, userId: string, authorization: string): Observable<any> {
    const params1 = new HttpParams().set('userId', userId);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Authorization": authorization
    });
    const options = {headers, params: params1};

    return this.httpClient.post<any>(this.url + '/address', addressInfo, options);
  }

  updateAddress(updatedAddress: AddressSuccess, userId: string, authorization: string): Observable<any> {
    const params1 = new HttpParams().set('userId', userId);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorization
    });
    const options = {headers, params: params1};
    return this.httpClient.put<any>(this.url + '/address', updatedAddress, options);
  }

  deleteAddress(addressId: string, userId: string, authorization: string, type:string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorization
    });

    const options = {headers};
    return this.httpClient.delete<any>(this.url + '/address?userId='+ userId + '&addressId=' + addressId+'&type='+type, options);
  }
}
